import React from 'react';
import TableHeader from './ConfigurationSetTableHeader'
import TableRow from './ConfigurationSetTableRow';

/**
 * @param {{
 *  className?: HTMLAttributes<HTMLDivElement>.className?: string | undefined;
 *  sortBySelected: string;
 *  sortBy: (sortIndex: string) => void;
 *  sortOrder: "Ascending" | "Descending";
 *  filteredsettingList: *[];
 *  dateFormat: string;
 *  hyperfinds: *[];
 *  rightPanelHandler: (sideAction: any, selectedItem: any) => void;
 *  isArchive: boolean?;
 * }} param0 
 */
const ConfigurationSetTable = ({
    className,
    sortBySelected,
    sortBy,
    sortOrder,
    filteredsettingList,
    dateFormat,//TODO 2023/05/05 - kathy - Use user date format set on hris 
    hyperfinds,
    rightPanelHandler,
    isArchive = false,
}) => (
    <div className={className || undefined}>
        <TableHeader
            sortBy={sortBy}
            sortBySelected={sortBySelected}
            sortOrder={sortOrder}
        />
        {filteredsettingList.map((bid, index) =>
            <TableRow
                key={bid.id}
                dateFormat={dateFormat}
                showRightPanel={rightPanelHandler}
                item={bid}
                index={index}
                hyperFindList={hyperfinds}
                isEditable={!isArchive}
                isDeletable={!isArchive}
            />
        )}
    </div>
);

export default ConfigurationSetTable;
